// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


// ng b --prod --configuration=fr 
export const environment = {
  production: false,
  apiUrl: 'http://localhost:62952/api',
  // apiUrl: 'http://webapi.agilya.com/api',
  locale: 'en',
  webRootApi: 'http://localhost:62952/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
